// extracted by mini-css-extract-plugin
export default {"container":"Snjy85BeMuTzgZkLpHH5A","content":"_12encnRIjZS8c2bIjysYWV"};